import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OnboardingSurveyCompleted } from '../types';
import META from './useTrackCompletedOnboardingSize.meta';

export const useTrackCompletedOnboardingSize = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingSize = useCallback(
    (params: OnboardingSurveyCompleted) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackCompletedOnboardingSize };
};
